import React from 'react';
import SupportChatInterface from '../../components/Chat/SupportChatInterface';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft, MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const SupportChatPage = () => {
    const { t } = useTranslation(['support']);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const question = searchParams.get('question');
    const category = searchParams.get('category');
    const subCategory = searchParams.get('subCategory');
    const description = searchParams.get('description');
    const categoryId = searchParams.get('categoryId');
    const subCategoryId = searchParams.get('subCategoryId');
    const requestId = searchParams.get('requestId');
    const ticketId = searchParams.get('ticketId');

    return (
        <div className="h-full flex flex-col bg-white" data-testid="support-chat-page-container">
            {/* Support Headline */}
            <div className="bg-gradient-to-r from-[#4ABDBD] to-[#3AA8A8] text-white px-6 py-4 shadow-md" data-testid="support-chat-page-header">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => navigate('/support')}
                            className="p-2 hover:bg-white/20 rounded-full transition-colors"
                            data-testid="support-chat-page-back-button"
                        >
                            <ArrowLeft size={20} data-testid="support-chat-page-back-icon" />
                        </button>
                        <div className="flex items-center gap-2">
                            <MessageCircle size={24} data-testid="support-chat-page-title-icon" />
                            <div>
                                <h1 className="text-xl font-bold" data-testid="support-chat-page-title">{t('support.support_chat')}</h1>
                                <p className="text-sm text-white/90" data-testid="support-chat-page-subtitle">
                                    {category && subCategory
                                        ? `${category} - ${subCategory}`
                                        : t('support.get_instant_help')
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Chat Interface */}
            <div className="flex-1 overflow-hidden" data-testid="support-chat-page-interface-container">
                <SupportChatInterface 
                    initialQuestion={question}
                    category={category}
                    subCategory={subCategory}
                    description={description}
                    categoryId={categoryId}
                    subCategoryId={subCategoryId}
                    requestId={requestId}
                    ticketId={ticketId}
                />
            </div>
        </div>
    );
};

export default SupportChatPage;

